import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/f069ab8c3cca1cd2e7e5c73c21a3a912.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-5xl lg:text-6xl font-heading font-bold text-white mb-6 leading-tight">
            Mobile Notary Services
          </h1>
          <p className="text-xl lg:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed font-body">
            Professional notarization services that come to you—at your home, office, hospital, or any location that's convenient
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a 
              href="/contact"
              className="px-8 py-4 bg-teal text-white rounded-lg font-semibold text-base hover:bg-teal/90 transition-all whitespace-nowrap cursor-pointer"
            >
              Schedule Notary Service
            </a>
            <a 
              href="#services"
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white rounded-lg font-semibold text-base hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              View Services
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
